import { FETCH_TIMEZONE, UPDATE_TIMEZONE } from "../../actions/actionTypes";

export const timezoneReducer = (state = {}, action) => {
    if (action && action.payload && !action.payload.errors) {
      switch (action.type) {
        case FETCH_TIMEZONE:
          const fetchedTimezone = action.payload.customerTimezone || "";
          const newState = {
            ...state,
            customerTimezone: fetchedTimezone
          };
          return newState;

        case UPDATE_TIMEZONE:
          const updatedTimezone = action.payload.customerTimezone;
          const updatedState = {
            ...state,
            customerTimezone: updatedTimezone
          };
          return updatedState;

        default:
          return state;
      }
    } else {
      return state;
    }
  };